import React from 'react';
import { ArrowRight } from 'lucide-react';
import readyToTransformImage from '@assets/LandingPage/EnterpriseTraning.png';
import './ReadyToTransformHero.css';

export default function ReadyToTransformHero() {
  return (
    <section className="ready-transform-section">
      <div className="ready-transform-content">
        <div className="ready-transform-text">
          <h1 className="ready-transform-title">
            Ready to Transform Your Enterprise Training?
          </h1>
          <p className="ready-transform-subtitle">
            Join the ranks of successful companies who've revolutionized their workforce development.
          </p>
          <button className="ready-transform-btn">
            <span>Watch Demo for free</span>
            <ArrowRight size={20} className="ready-transform-btn-arrow" />
          </button>
        </div>

        <div className="ready-transform-image-container">
          <img
            src={readyToTransformImage}
            alt="Team collaborating in meeting"
            className="ready-transform-image"
          />
        </div>
      </div>
    </section>
  );
}
